import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { merge } from '../sx';
import { Box } from '..';
var REGION_ORDER = {
  header: 0,
  paneStart: 1,
  content: 2,
  paneEnd: 3,
  footer: 4
};
var SPACING_MAP = {
  none: 0,
  condensed: 3,
  normal: [3, null, null, 4]
};
var PageLayoutContext = /*#__PURE__*/React.createContext({
  padding: 'normal',
  rowGap: 'normal',
  columnGap: 'normal'
}); // ----------------------------------------------------------------------------
// PageLayout

var containerWidths = {
  full: '100%',
  medium: '768px',
  large: '1012px',
  xlarge: '1280px'
}; // TODO: refs

var Root = function Root(_ref) {
  var _ref$containerWidth = _ref.containerWidth,
      containerWidth = _ref$containerWidth === void 0 ? 'xlarge' : _ref$containerWidth,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'normal' : _ref$padding,
      _ref$rowGap = _ref.rowGap,
      rowGap = _ref$rowGap === void 0 ? 'normal' : _ref$rowGap,
      _ref$columnGap = _ref.columnGap,
      columnGap = _ref$columnGap === void 0 ? 'normal' : _ref$columnGap,
      children = _ref.children,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx;
  return /*#__PURE__*/React.createElement(PageLayoutContext.Provider, {
    value: {
      padding: padding,
      rowGap: rowGap,
      columnGap: columnGap
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: merge({
      padding: SPACING_MAP[padding]
    }, sx)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      maxWidth: containerWidths[containerWidth],
      marginX: 'auto',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, children)));
};

Root.displayName = "Root";
Root.displayName = 'PageLayout'; // ----------------------------------------------------------------------------
// Divider (internal)

var horizontalDividerVariants = {
  none: {
    display: 'none'
  },
  line: {
    display: 'block',
    height: 1,
    backgroundColor: 'border.default'
  },
  filled: {
    display: 'block',
    height: 8,
    backgroundColor: 'canvas.inset',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    boxShadow: function boxShadow(theme) {
      return "inset 0 -1px 0 0 ".concat(theme.colors.border.default, ", inset 0 1px 0 0 ").concat(theme.colors.border.default);
    }
  }
};

function negateSpacingValue(value) {
  if (Array.isArray(value)) {
    // Not using recursion to avoid deeply nested arrays
    return value.map(function (v) {
      return v === null ? null : -v;
    });
  }

  return value === null ? null : -value;
}

var HorizontalDivider = function HorizontalDivider(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'none' : _ref2$variant,
      _ref2$variantWhenNarr = _ref2.variantWhenNarrow,
      variantWhenNarrow = _ref2$variantWhenNarr === void 0 ? 'inherit' : _ref2$variantWhenNarr,
      _ref2$sx = _ref2.sx,
      _sx = _ref2$sx === void 0 ? {} : _ref2$sx;

  var _React$useContext = React.useContext(PageLayoutContext),
      padding = _React$useContext.padding;

  return /*#__PURE__*/React.createElement(Box // eslint-disable-next-line @typescript-eslint/no-explicit-any
  , {
    sx: function sx(theme) {
      return merge(_objectSpread(_objectSpread({
        // Stretch divider to viewport edges on narrow screens
        marginX: negateSpacingValue(SPACING_MAP[padding])
      }, horizontalDividerVariants[variantWhenNarrow === 'inherit' ? variant : variantWhenNarrow]), {}, _defineProperty({}, "@media screen and (min-width: ".concat(theme.breakpoints[1], ")"), _objectSpread({
        marginX: '0 !important'
      }, horizontalDividerVariants[variant]))), _sx);
    }
  });
};

HorizontalDivider.displayName = "HorizontalDivider";
var verticalDividerVariants = {
  none: {
    display: 'none'
  },
  line: {
    display: 'block',
    width: 1,
    backgroundColor: 'border.default'
  },
  filled: {
    display: 'block',
    width: 8,
    backgroundColor: 'canvas.inset',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    boxShadow: function boxShadow(theme) {
      return "inset -1px 0 0 0 ".concat(theme.colors.border.default, ", inset 1px 0 0 0 ").concat(theme.colors.border.default);
    }
  }
};

var VerticalDivider = function VerticalDivider(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'none' : _ref3$variant,
      _ref3$variantWhenNarr = _ref3.variantWhenNarrow,
      variantWhenNarrow = _ref3$variantWhenNarr === void 0 ? 'inherit' : _ref3$variantWhenNarr,
      _ref3$sx = _ref3.sx,
      _sx2 = _ref3$sx === void 0 ? {} : _ref3$sx;

  return /*#__PURE__*/React.createElement(Box // eslint-disable-next-line @typescript-eslint/no-explicit-any
  , {
    sx: function sx(theme) {
      return merge(_objectSpread(_objectSpread({
        height: '100%'
      }, verticalDividerVariants[variantWhenNarrow === 'inherit' ? variant : variantWhenNarrow]), {}, _defineProperty({}, "@media screen and (min-width: ".concat(theme.breakpoints[1], ")"), _objectSpread({}, verticalDividerVariants[variant]))), _sx2);
    }
  });
};

VerticalDivider.displayName = "VerticalDivider";

var Header = function Header(_ref4) {
  var _ref4$divider = _ref4.divider,
      divider = _ref4$divider === void 0 ? 'none' : _ref4$divider,
      _ref4$dividerWhenNarr = _ref4.dividerWhenNarrow,
      dividerWhenNarrow = _ref4$dividerWhenNarr === void 0 ? 'inherit' : _ref4$dividerWhenNarr,
      children = _ref4.children,
      _ref4$sx = _ref4.sx,
      sx = _ref4$sx === void 0 ? {} : _ref4$sx;

  var _React$useContext2 = React.useContext(PageLayoutContext),
      rowGap = _React$useContext2.rowGap;

  return /*#__PURE__*/React.createElement(Box, {
    as: "header",
    sx: merge({
      order: REGION_ORDER.header,
      width: '100%',
      marginBottom: SPACING_MAP[rowGap]
    }, sx)
  }, children, /*#__PURE__*/React.createElement(HorizontalDivider, {
    variant: divider,
    variantWhenNarrow: dividerWhenNarrow,
    sx: {
      marginTop: SPACING_MAP[rowGap]
    }
  }));
};

Header.displayName = "Header";
Header.displayName = 'PageLayout.Header'; // ----------------------------------------------------------------------------
// PageLayout.Content
// TODO: Account for pane width when centering content

var contentWidths = {
  full: '100%',
  medium: '768px',
  large: '1012px',
  xlarge: '1280px'
};

var Content = function Content(_ref5) {
  var _ref5$width = _ref5.width,
      width = _ref5$width === void 0 ? 'full' : _ref5$width,
      children = _ref5.children,
      _ref5$sx = _ref5.sx,
      sx = _ref5$sx === void 0 ? {} : _ref5$sx;
  return /*#__PURE__*/React.createElement(Box, {
    as: "main",
    sx: merge({
      order: REGION_ORDER.content,
      // Set flex-basis to 0% to allow flex-grow to control the width of the content region.
      // Without this, the content region could wrap onto a different line
      // than the pane region on wide viewports if its contents are too wide.
      flexBasis: 0,
      flexGrow: 1,
      flexShrink: 1,
      minWidth: 1 // Hack to prevent overflowing content from pushing the pane region to the next line

    }, sx)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      maxWidth: contentWidths[width],
      marginX: 'auto'
    }
  }, children));
};

Content.displayName = "Content";
Content.displayName = 'PageLayout.Content'; // ----------------------------------------------------------------------------
// PageLayout.Pane

var panePositions = {
  start: REGION_ORDER.paneStart,
  end: REGION_ORDER.paneEnd
};
var paneWidths = {
  small: ['100%', null, '240px', '256px'],
  medium: ['100%', null, '256px', '296px'],
  large: ['100%', null, '256px', '320px', '336px']
};

var Pane = function Pane(_ref6) {
  var _ref6$position = _ref6.position,
      position = _ref6$position === void 0 ? 'end' : _ref6$position,
      _ref6$positionWhenNar = _ref6.positionWhenNarrow,
      positionWhenNarrow = _ref6$positionWhenNar === void 0 ? 'inherit' : _ref6$positionWhenNar,
      _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? 'medium' : _ref6$width,
      _ref6$divider = _ref6.divider,
      divider = _ref6$divider === void 0 ? 'none' : _ref6$divider,
      _ref6$dividerWhenNarr = _ref6.dividerWhenNarrow,
      dividerWhenNarrow = _ref6$dividerWhenNarr === void 0 ? 'inherit' : _ref6$dividerWhenNarr,
      children = _ref6.children,
      _ref6$sx = _ref6.sx,
      _sx3 = _ref6$sx === void 0 ? {} : _ref6$sx;

  var _React$useContext3 = React.useContext(PageLayoutContext),
      rowGap = _React$useContext3.rowGap,
      columnGap = _React$useContext3.columnGap;

  var computedPositionWhenNarrow = positionWhenNarrow === 'inherit' ? position : positionWhenNarrow;
  var computedDividerWhenNarrow = dividerWhenNarrow === 'inherit' ? divider : dividerWhenNarrow;
  return /*#__PURE__*/React.createElement(Box, {
    as: "aside" // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    sx: function sx(theme) {
      var _mediaScreenAndM, _merge;

      return merge((_merge = {
        order: panePositions[computedPositionWhenNarrow],
        display: 'flex',
        flexDirection: computedPositionWhenNarrow === 'end' ? 'column' : 'column-reverse',
        width: '100%',
        marginX: 0
      }, _defineProperty(_merge, computedPositionWhenNarrow === 'end' ? 'marginTop' : 'marginBottom', SPACING_MAP[rowGap]), _defineProperty(_merge, "@media screen and (min-width: ".concat(theme.breakpoints[1], ")"), (_mediaScreenAndM = {
        width: 'auto'
      }, _defineProperty(_mediaScreenAndM, position === 'end' ? 'marginLeft' : 'marginRight', SPACING_MAP[columnGap]), _defineProperty(_mediaScreenAndM, "marginY", "0 !important"), _defineProperty(_mediaScreenAndM, "flexDirection", position === 'end' ? 'row' : 'row-reverse'), _defineProperty(_mediaScreenAndM, "order", panePositions[position]), _mediaScreenAndM)), _merge), _sx3);
    }
  }, /*#__PURE__*/React.createElement(HorizontalDivider, {
    variant: "none",
    variantWhenNarrow: computedDividerWhenNarrow,
    sx: _defineProperty({}, computedPositionWhenNarrow === 'end' ? 'marginBottom' : 'marginTop', SPACING_MAP[rowGap])
  }), /*#__PURE__*/React.createElement(VerticalDivider, {
    variant: divider,
    variantWhenNarrow: "none",
    sx: _defineProperty({}, position === 'end' ? 'marginRight' : 'marginLeft', SPACING_MAP[columnGap])
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: paneWidths[width]
    }
  }, children));
};

Pane.displayName = "Pane";
Pane.displayName = 'PageLayout.Pane'; // ----------------------------------------------------------------------------
// PageLayout.Footer

var Footer = function Footer(_ref7) {
  var _ref7$divider = _ref7.divider,
      divider = _ref7$divider === void 0 ? 'none' : _ref7$divider,
      _ref7$dividerWhenNarr = _ref7.dividerWhenNarrow,
      dividerWhenNarrow = _ref7$dividerWhenNarr === void 0 ? 'inherit' : _ref7$dividerWhenNarr,
      children = _ref7.children,
      _ref7$sx = _ref7.sx,
      sx = _ref7$sx === void 0 ? {} : _ref7$sx;

  var _React$useContext4 = React.useContext(PageLayoutContext),
      rowGap = _React$useContext4.rowGap;

  return /*#__PURE__*/React.createElement(Box, {
    as: "footer",
    sx: merge({
      order: REGION_ORDER.footer,
      width: '100%',
      marginTop: SPACING_MAP[rowGap]
    }, sx)
  }, /*#__PURE__*/React.createElement(HorizontalDivider, {
    variant: divider,
    variantWhenNarrow: dividerWhenNarrow,
    sx: {
      marginBottom: SPACING_MAP[rowGap]
    }
  }), children);
};

Footer.displayName = "Footer";
Footer.displayName = 'PageLayout.Footer'; // ----------------------------------------------------------------------------
// Export

export var PageLayout = Object.assign(Root, {
  Header: Header,
  Content: Content,
  Pane: Pane,
  Footer: Footer
});